import * as React from "react";
import auth from "../../../../Auth";
import {  MenuRender } from "../../../../Shared/GridComponents/CommonComponents";
import { faPlusCircle, faFileExcel, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import ReactExport from "react-export-excel-fixed-xlsx";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
export function DefaultActions(props, locId) {
    const { dataItem } = props;
    var defaultActions = [
        {
            action: "View Schedule", //To view the schedule(generate, publish & assign)
            permCode: AppPermissions.VIEW_SCHEDULE,
            nextState: "",
            icon: "faEye",
            linkUrl: `/admin/client/loc/${locId}/dept/${dataItem.departmentId}/manage/schedule/${dataItem.scheduleId}/viewschedule`,
            cssStyle: {
                display: dataItem.status == "Active" ? "block" : "none",
            },
        },
        {
            action: "Edit",
            permCode: AppPermissions.CREATE_SCHEDULE,
            nextState: "",
            icon: "faPencilAlt"

        },
        {
            action: "Remove",
            permCode: AppPermissions.DELETE_SCHEDULE,
            nextState: "",
            icon: "faTrashAlt",
            cssStyle: { display: "block" },
        },
        {
            action: `${dataItem.status == "Active" ? "Inactivate" : "Activate"}`,
            permCode: AppPermissions.CREATE_SCHEDULE,
            nextState: "",
            icon: "faTimesCircle",
            cssStyle: { display: "block" },
        },
        {
            action: "View Events",
            permCode: AppPermissions.EVENT_VIEW,
            nextState: "",
            icon: "faEye",
            linkUrl: `/admin/eventslogs/manage/${dataItem.scheduleId}`,
        },

    ];
    return defaultActions;
}

export function ExportExcel(data?) {
    return (
        <ExcelFile
            element={
                <div className="pb-1 pt-1 w-100 myorderGlobalicons">
                    <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Export to Excel{" "}
                </div>
            }
            filename="Manage Schedule"
        >
            <ExcelSheet data={data} name="Manage Schedule">
                <ExcelColumn label="Schedule Name" value="scheduleName" />
                <ExcelColumn label="Status" value="recordStatus" />
            </ExcelSheet>
        </ExcelFile>
    )
}

export function AddNewSchedule(Add) {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={Add}>

            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add New Schedule{" "}
        </div>
    );
}

export function CustomMenu (excelData, Add) {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
                {auth.hasPermissionV2(AppPermissions.CLIENT_DIV_CREATE) && <MenuItem render={() => AddNewSchedule(Add)} />}
                <MenuItem render={() => ExportExcel(excelData)} />
            </MenuItem>
        </Menu>
    );
}